import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#F0FDF4,#FEF9C3)',display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
      <div className="card" style={{width:'100%',maxWidth:'420px'}}>
        <div style={{textAlign:'center',marginBottom:'2rem'}}>
          <Link to="/" style={{textDecoration:'none'}}>
            <div style={{fontSize:'48px',marginBottom:'8px'}}>🏘</div>
          </Link>
          <h1 style={{fontSize:'24px',fontWeight:800}}>Welcome back</h1>
          <p style={{color:'#6B7280',fontSize:'14px'}}>Sign in to your CommunityBridge account</p>
        </div>
        {error && <div className="alert alert-red">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" required/>
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required/>
          </div>
          <button type="submit" className="btn btn-primary" style={{width:'100%',padding:'12px',fontSize:'15px',marginTop:'8px',justifyContent:'center'}} disabled={loading}>
            {loading ? 'Signing in...' : '→ Sign In'}
          </button>
        </form>
        <p style={{textAlign:'center',marginTop:'1.5rem',fontSize:'14px',color:'#6B7280'}}>
          No account? <Link to="/signup" style={{color:'#16A34A',fontWeight:600}}>Sign up free</Link>
        </p>
      </div>
    </div>
  );
}
